import { render, staticRenderFns } from "./RegionTreeModal.vue?vue&type=template&id=45cc0d35"
import script from "./RegionTreeModal.vue?vue&type=script&lang=js"
export * from "./RegionTreeModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports